module.exports = {
    "Clear search": `Suche zur\xfccksetzen`
};


//# sourceMappingURL=de-DE.main.js.map
